/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Already_RegisteredInputs */



/**
* | output |
* | --- |
* | "Already registered" |
*
* @param {Err_Tournament_Already_RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_already_registered = /** @type {((inputs?: Err_Tournament_Already_RegisteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Already_RegisteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déjà inscrit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya inscrito")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Já inscrito")
	if (locale === "it") return /** @type {LocalizedString} */ ("Già iscritto")
	return /** @type {LocalizedString} */ ("Already registered")
});